import { useState } from "react";
import { Modal } from "@Components/ui";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import Image from "components/Image";
import RecipeSlider from "../recipe-gallery/RecipeSlider";
import { AccordionItem } from "./accordion-item";
import classes from "./ProductAccordion.module.scss";

interface IAccordionData {
  expandable1Content: {};
  expandable1Label: string;
  expandable2Label: string;
  expandable3Label: string;
  prepTips: string;
  isFixedPrice: boolean;
  nutritionImage: {
    url: string;
    title: string;
    width: number;
    height: number;
  };
  recipes: any;
}
type ProductAccordionProps = {
  accordionData: IAccordionData;
};

export const ProductAccordion = ({ accordionData }: ProductAccordionProps) => {
  const [showModal, setShowModal] = useState(false);
  const closeModalHandler = () => {
    setShowModal(false);
  };

  const {
    expandable1Content,
    expandable1Label,
    expandable2Label,
    expandable3Label,
    prepTips,
    nutritionImage,
    isFixedPrice,
    recipes,
  } = accordionData;

  return (
    <div className={classes["product-accordion"]}>
      {!isFixedPrice && (
        <AccordionItem key={expandable1Label} title={expandable1Label}>
          <CmsTextEditorContent content={expandable1Content} />
        </AccordionItem>
      )}
      {prepTips ? (
        <AccordionItem key={expandable2Label} title={expandable2Label}>
          <p>{prepTips}</p>
        </AccordionItem>
      ) : (
        <></>
      )}
      {recipes?.length > 0 && (
        <AccordionItem key={expandable3Label} title={expandable3Label}>
          <RecipeSlider recipeSliderItems={recipes} />
        </AccordionItem>
      )}

      {showModal && (
        <Modal show={showModal} onClose={closeModalHandler}>
          <div className={classes["image-wrapper"]}>
            <Image
              src={`${nutritionImage?.url}?fm=webp&w=1920&h=1080`}
              alt={nutritionImage?.title}
              height={650}
              width={400}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
